export function downloadBlob(blob: Blob, filename: string): void {
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement("a")
  link.href = url
  link.download = filename
  link.click()
  window.URL.revokeObjectURL(url)
}

export async function downloadMultipleBlobs(
  downloads: Array<{ blob: Blob; filename: string }>,
  delayMs: number = 500
): Promise<void> {
  for (let i = 0; i < downloads.length; i++) {
    const { blob, filename } = downloads[i]
    downloadBlob(blob, filename)

    // Add delay between downloads (except after the last one)
    if (i < downloads.length - 1) {
      await new Promise((resolve) => setTimeout(resolve, delayMs))
    }
  }
}
